import { EconomyRole as MyType } from '@shapeable/lli-types';
import { EntityConfig, entityCoreFormFields } from '@shapeable/core';

export const EconomyRole: EntityConfig<MyType> = {
  name: 'EconomyRole',
  label: 'Country Role',
  type: 'child',
  list: {
    resultsVariant: 'list',
  },
  table: {
    fieldNames: ["person", "role"],
  },

  autoRoutes: ['create', 'update'],
  form: {
    fields: {
      ...entityCoreFormFields,
      economy: { type: 'linked', entityTypeName: 'Economy', variant: 'forPerson' },
      person: { type: 'linked', entityTypeName: 'Person' },
      role: { type: 'linked', entityTypeName: 'Role' },
      description: { type: 'longText' },
    }
  },
}; 